export default {
  address: ['user-input', 'map', 'underground'],
  'about-object': [
    'common/cadastral-number',
    'housing-type',
    'common/share-amount',
    'rooms-count',
    'room-type',
    'urban-total-area',
    'floor',
    'all-rooms-area',
    'living-area',
    'kitchen-area',
    'visual-divider',
    'loggias-count',
    'balconies-count',
    'window-view-type',
    'visual-divider',
    'separate-wcs-count',
    'combined-wcs-count',
    'visual-divider',
    'repair-type',
    'has-phone',
  ],
  'about-building': [
    'name-and-year',
    'material-type-and-series',
    'ceiling-height',
    'passenger-lifts',
    'cargo-lifts',
    'has-ramp',
    'in-house',
    'parking',
  ],
  'price-and-deal-terms': ['price', 'sale-type', 'agent-bonus'],
};
